import React from "react";
import imgv2c from "../img/imgv2c.png";
// import HeroBg from "../img/HeroBg.jpg";
// import { heroData } from "../utils/data";
// import video from "../img/video.mp4";
import gif from "../img/imggif.gif";
function SETUP() {
  return (
    <section
      className="grid grid-cols-1 md:grid-cols-2 gap-2 w-full "
      id="home"
    >
      {/* <div className="py-2 flex-1 flex items-center relative">
        {
          <img
            src={gif}
            className="ml-auto h-420 w-full lg:w-auto lg:h-300"
            alt="img"
          />
        }
      </div> */}
      <div className="py-2 flex-1 flex flex-col items-start justify-center gap-6">
        <div className="flex items-center gap-2 justify-center bg-gray-300 px-4 py-1 rounded-full">
          <p className="text-base text-gray-500 font-semibold">AQUAPHONIC</p>
          <div className="w-10 h-10 bg-white rounded-full overflow-hidden drop-shadow-xl">
            <img
              src={imgv2c}
              className="w-full h-full object-contain"
              alt="delivery"
            />
          </div>
        </div>
        <p className="text-[2.5rem] lg:text-[3rem] font-bold tracking-wide text-slate-700">
          Agriculture with a new Skill
          <br />{" "}
          <span className="text-orange-600 text-[3rem] lg:text-[3rem]">
            In Your City
          </span>
        </p>
        {/* <p className="text-base text-slate-400 text-center md:text-left md:w-[80%]">
          We believe Aquaponics is the way to go for commercial growing to
          kitchen growing. We wish everyone of us{" "}
          <span className="text-orange-600">grow our own food</span> and become
          self sustainable one day. If you are ready to Grow your own food and
          need help on where to start, please contact us we will help you to
          setup your Home Garden on a Tabletop or Rooftop or Backyard level.
        </p> */}
        <button
          onClick={"/"}
          className="bg-gradient-to-br from-orange-400 to-orange-500 w-full md:w-auto px-4 py-2  rounded-lg hover:shadow-lg transition-all ease-in-out duration-100"
        >
          Know Where Your Food Grows
        </button>
        ++++++++++++++++++++++++++++++++++++++++++++++++++++++++img on
        left+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
        {/* <div  className="w-full h-full absolute top-0 left-0 flex items-center justify-center lg:px-4  py-6 gap-4 flex-wrap">
        {heroData &&
          heroData.map((n) => (
            <div
              key={n.id}
              className="  lg:w-200  p-4 bg-cardOverlay backdrop-blur-md rounded-3xl flex flex-col items-center justify-center drop-shadow-lg"
            >
              <img
                src={n.imageSrc}
                className="w-20 lg:w-44 -mt-10 lg:-mt-20 "
                alt="I1"
              />
              <p className="text-base lg:text-xl font-semibold text-textColor mt-2 lg:mt-4">
                {n.name}
              </p>

              <p className="text-[12px] lg:text-sm text-black font-semibold my-1 lg:my-3">
                {n.decp}
              </p>

              <p className="text-sm font-semibold text-headingColor">
                <span className="text-xs text-red-600">$</span> {n.price}
              </p>
            </div>
          ))}
      </div> */}
      </div>
    </section>
  );
}

export default SETUP;
